import React, { Component } from 'react';
import { Row, Form, FormGroup, Checkbox, ControlLabel, ButtonToolbar, Button } from 'react-bootstrap';
import Select from "react-select";
import { SelectOptionsHelper } from '../../../helpers/SelectOptionsHelper';

export class TmlFilterConfigs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            form: {
                lines: [],
                filterSelection: false,
                orientationsSelection: []
            }
        };
    }

    onContinue() {
        const { form } = this.state;

        const uniqueOrientations = [...new Set(form.orientationsSelection.map(item => item.orientation))];

        this.props.onContinue({
            lines: form.lines,
            filterSelection: form.filterSelection,
            orientationsSelection: uniqueOrientations
        });
    }

    onSelectValue(e, property) {
        const { form } = this.state;

        form[property] = e;

        this.setState({
            form: form
        });
    }

    onCheckValue(e, property) {
        const { form } = this.state;

        form[property] = e.target.checked;

        this.setState({
            form: form,
        });
    }

    renderOrientationsFilter() {
        const { form } = this.state;

        return (
            <FormGroup controlId="formOrientation">
                <ControlLabel>Orientação</ControlLabel>
                <Select
                    className="custom-multiselect"
                    placeholder="Sem filtro - Todas as orientações serão consideradas"
                    noOptionsMessage={() => "Sem Orientações Configuradas"}
                    onChange={(e) => this.onSelectValue(e, "orientationsSelection")}
                    options={SelectOptionsHelper.PathOrientations}
                    isMulti={true}
                    isClearable={true}
                    isOptionSelected={function (a) {
                        if (Array.isArray(form.orientationsSelection)) {
                            return form.orientationsSelection.includes(a);
                        }
                    }}
                    getOptionValue={value => value.orientation}
                    getOptionLabel={label => label.label}
                    value={form.orientationsSelection}
                />
            </FormGroup>
        )
    }

    render() {
        const { lines } = this.props;
        const { form } = this.state;

        return (
            <React.Fragment>
                <Form>
                    <FormGroup controlId="formLines">
                        <ControlLabel>Linhas</ControlLabel>
                        <Select
                            className="custom-multiselect"
                            placeholder="Sem filtro - Todas as linhas serão consideradas"
                            noOptionsMessage={() => "Sem Linhas Carregadas"}
                            onChange={(e) => this.onSelectValue(e, "lines")}
                            options={lines}
                            isMulti={true}
                            isOptionSelected={function (a) {
                                if (Array.isArray(form.lines)) {
                                    return form.lines.map(line => line.id).includes(a.id);
                                }
                            }}
                            getOptionValue={value => value.id}
                            getOptionLabel={label => (
                                <span>{label.code} | {label.name}</span>
                            )}
                            filterOption={(candidate, input) => {
                                if (undefined === input || null === input || "" === input) {
                                    return true;
                                }

                                const inputInvariantCase = input.toLowerCase();
                                const codeInvariantCase = candidate.data.code.toLowerCase();
                                const nameInvariantCase = candidate.data.name.toLowerCase();

                                if (codeInvariantCase.includes(inputInvariantCase) || nameInvariantCase.includes(inputInvariantCase)) {
                                    return true;
                                }

                                return `${codeInvariantCase} | ${nameInvariantCase}`.includes(inputInvariantCase);
                            }}
                            value={form.lines}
                        />
                    </FormGroup>

                    {form.lines.length > 0 && this.renderOrientationsFilter()}

                    <FormGroup>
                        <Checkbox
                            className="form-checkbox pull-left"
                            defaultChecked={form.filterSelection}
                            onChange={(e) => this.onCheckValue(e, "filterSelection")}>
                            Apenas Gerar Horários de Paragem das Linhas Filtradas
                        </Checkbox>
                    </FormGroup>
                    <FormGroup>
                        <Row></Row>
                    </FormGroup>
                </Form>
                <ButtonToolbar>
                    <Button onClick={() => this.onContinue()}> CONTINUAR </Button>
                    <Button onClick={() => this.props.onCancel()}> CANCELAR </Button>
                </ButtonToolbar>
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/schedules/tml/TmlFilterConfigs.js